import React from 'react';
import { RootState } from '../../app/store';
import { useSelector } from 'react-redux';
import { classNames } from '../../utils/classNames';
import { NavLink } from 'react-router-dom';
import { useTheme } from '../../utils/theme-context';
// import SelectSearchInside from '../../shared/market-select-search/select-inside-search';

const footerItems: { name: string, id: 'homeTab' | 'historyTab' | 'faqsTab', icon: React.ReactElement, iconDark: React.ReactElement, linkHref: string }[] = [
    { name: 'Home', id: 'homeTab', linkHref: '/', icon: <img src={'/assets/chat/home.svg'} className='object-contain w-[22px] mb-1' />, iconDark: <img src={'/assets/chat/home-white.svg'} className='object-contain w-[22px] mb-2' /> },
    { name: 'My History', id: 'historyTab', linkHref: '/history', icon: <img src={'/assets/chat/history.svg'} className='object-contain w-[22px] mb-1' />, iconDark: <img src={'/assets/chat/history-white.svg'} className='object-contain w-[22px] mb-2' /> },
    { name: 'FAQs', id: 'faqsTab', linkHref: '/faqs', icon: <img src={'/assets/chat/faq.svg'} className='object-contain w-[22px] mb-1' />, iconDark: <img src={'/assets/chat/faq-white.svg'} className='object-contain w-[22px] mb-2' /> }
]

const Footer = () => {
    const { theme } = useTheme();
    const features = useSelector(
        (state: RootState) => state.features
    );

    const onClickLink = (type: string) => {
        // if (type === 'Home') {

        // } else if (type === 'My History') {

        // } else {

        // }
    }

    return (
        <div className='md:h-30 w-full'>
            <div className='grid grid-cols-3 gap-4'>
                {footerItems?.map((item, idx: number) => {
                    return (
                        <div className='relative' key={item.id}>
                            {!features[item.id] && <div className='absolute top-0 left-0 w-full z-10' />}
                            <NavLink
                                to={item.linkHref}
                                key={idx}
                                onClick={() => onClickLink(item?.name)}
                                className={classNames('flex flex-col items-center justify-center p-2 cursor-pointer hover:opacity-80', features[item.id] === false ? 'opacity-10' : '')}>
                                {theme === 'dark' ? item?.iconDark : item?.icon}
                                <p className='dark:text-primary-darkMode text-sm'>{item?.name}</p>
                            </NavLink>
                        </div>

                    )
                })}
            </div>
        </div>
    )
}

export default Footer;